"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const react_linkify_1 = __importDefault(require("react-linkify"));
const AxisBuilder_1 = __importDefault(require("../../../axes/AxisBuilder"));
const expressions_1 = require("@mwater/expressions");
const valueFormatter_1 = require("../../../valueFormatter");
const color_1 = __importDefault(require("color"));
const expressions_ui_1 = require("@mwater/expressions-ui");
class TableChartViewComponent extends react_1.default.Component {
    shouldComponentUpdate(prevProps) {
        return !lodash_1.default.isEqual(prevProps, this.props);
    }
    render() {
        const style = {
            width: this.props.width,
            height: this.props.height
        };
        return (react_1.default.createElement("div", { style: style, className: "overflow-auto-except-print" },
            react_1.default.createElement("div", { style: { fontWeight: "bold", textAlign: "center" } }, this.props.design.titleText),
            react_1.default.createElement(TableContentsComponent, { columns: this.props.design.columns, table: this.props.design.table, data: this.props.data, schema: this.props.schema, dataSource: this.props.dataSource, onRowClick: this.props.onRowClick })));
    }
}
exports.default = TableChartViewComponent;
class TableContentsComponent extends react_1.default.Component {
    static contextType = expressions_ui_1.LocaleContext;
    constructor(props) {
        super(props);
        this.state = {
            sort: null,
            data: props.data.main
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.setState({ data: this.sortData() });
    }
    sortData = () => {
        if (!this.state.sort)
            return this.props.data.main;
        return lodash_1.default.sortByOrder(this.props.data.main, [`c${this.state.sort.column}`], [this.state.sort.direction]);
    };
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextProps.columns !== this.props.columns && !lodash_1.default.isEqual(nextProps.columns, this.props.columns)) {
            return true;
        }
        if (nextProps.data !== this.props.data && !lodash_1.default.isEqual(nextProps.data, this.props.data)) {
            return true;
        }
        if (nextProps.schema !== this.props.schema) {
            return true;
        }
        if (nextProps.schema !== this.props.schema) {
            return true;
        }
        if (nextState.sort !== this.state.sort) {
            return true;
        }
        if (nextState.data !== this.state.data && !lodash_1.default.isEqual(nextState.data, this.state.data)) {
            return true;
        }
        return false;
    }
    handleRowClick = (rowIndex) => {
        const row = this.state.data[rowIndex];
        if (row && row.id && this.props.onRowClick) {
            return this.props.onRowClick(this.props.table, row.id);
        }
    };
    handleSort = (colIndex) => {
        const currentSort = this.state.sort?.column === colIndex ? this.state.sort?.direction : null;
        this.setState({
            sort: {
                column: colIndex,
                direction: currentSort === "asc" ? "desc" : "asc"
            }
        });
    };
    renderHeaderCell(index) {
        const axisBuilder = new AxisBuilder_1.default({ schema: this.props.schema });
        const column = this.props.columns[index];
        //(this.state.sort?.direction === 'asc' ? "":"")
        const text = column.headerText ?? (column.textAxis ? axisBuilder.summarizeAxis(column.textAxis, this.context) : "");
        return (react_1.default.createElement("th", { key: index, style: { cursor: "pointer" }, onClick: () => this.handleSort(index) },
            text,
            this.state.sort?.column === index ? (react_1.default.createElement("span", { style: { marginLeft: 10 }, className: `fa ${this.state.sort?.direction === "asc" ? "fa-sort-asc" : "fa-sort-desc"}` })) : undefined));
    }
    renderHeader() {
        return (react_1.default.createElement("thead", { key: "head" },
            react_1.default.createElement("tr", { key: "head" }, lodash_1.default.map(this.props.columns, (column, i) => this.renderHeaderCell(i)))));
    }
    renderFooterCell(index) {
        const exprUtils = new expressions_1.ExprUtils(this.props.schema);
        const column = this.props.columns[index];
        if (!column.textAxis)
            return null;
        const exprType = exprUtils.getExprType(column.textAxis?.expr);
        let node = null;
        if (exprType && exprType == "number") {
            node = `${lodash_1.default.capitalize(column.summaryType)}: ${(0, valueFormatter_1.formatValue)(exprType, this.props.data.summary[`c${index}`], column.format)}`;
        }
        return node;
    }
    renderFooter() {
        if (!this.props.data.summary) {
            return null;
        }
        return (react_1.default.createElement("tfoot", { key: "foot" },
            react_1.default.createElement("tr", { key: "foot" }, lodash_1.default.map(this.props.columns, (column, i) => react_1.default.createElement("th", { key: i }, this.renderFooterCell(i))))));
    }
    renderImage(id) {
        const url = this.props.dataSource.getImageUrl(id);
        return (react_1.default.createElement("a", { href: url, onClick: (e) => { e.stopPropagation(); }, key: id, target: "_blank", style: { paddingLeft: 5, paddingRight: 5 } }, T `Image`));
    }
    renderCell(rowIndex, columnIndex) {
        const axisBuilder = new AxisBuilder_1.default({ schema: this.props.schema });
        let node;
        const row = this.state.data[rowIndex];
        const column = this.props.columns[columnIndex];
        // Set background color
        let backgroundColor = "transparent";
        let textColor = "inherit";
        const exprUtils = new expressions_1.ExprUtils(this.props.schema);
        if (!column.textAxis) {
            node = null;
        }
        else {
            const exprType = exprUtils.getExprType(column.textAxis.expr);
            // Get value
            let value = row[`c${columnIndex}`];
            if (column.backgroundColorAxis) {
                backgroundColor = axisBuilder.getValueColor(column.backgroundColorAxis, row[`bc${columnIndex}`]) ?? "#fff";
            }
            if (value == null) {
                node = null;
            }
            else {
                // Parse if should be JSON
                if (["image", "imagelist", "geometry", "text[]"].includes(exprType || "") && lodash_1.default.isString(value)) {
                    try {
                        value = JSON.parse(value);
                    }
                    catch (e) {
                        // Ignore as can happen when re-arranging columns
                        value = null;
                    }
                }
                // Convert to node based on type
                switch (exprType) {
                    case "text":
                        if (lodash_1.default.isString(value)) {
                            node = react_1.default.createElement(react_linkify_1.default, { properties: { target: "_blank" } }, value);
                        }
                        break;
                    case "number":
                    case "geometry":
                        node = (0, valueFormatter_1.formatValue)(exprType, value, column.format);
                        break;
                    case "boolean":
                    case "enum":
                        node = exprUtils.stringifyExprLiteral(column.textAxis?.expr, value, this.context);
                        break;
                    case "enumset":
                    case "text[]":
                        if (lodash_1.default.isArray(value)) {
                            node = exprUtils.stringifyExprLiteral(column.textAxis?.expr, value, this.context);
                        }
                        break;
                    case "date":
                        if (lodash_1.default.isString(value)) {
                            node = (0, valueFormatter_1.formatValue)(exprType, value, column.format);
                        }
                        break;
                    case "datetime":
                        if (lodash_1.default.isString(value)) {
                            node = (0, valueFormatter_1.formatValue)(exprType, value, column.format);
                        }
                        break;
                    case "image":
                        if (lodash_1.default.isObject(value) && value.id != null) {
                            node = this.renderImage(value.id);
                        }
                        break;
                    case "imagelist":
                        if (lodash_1.default.isArray(value)) {
                            node = lodash_1.default.map(value, (v) => this.renderImage(v.id));
                        }
                        break;
                    default:
                        node = "" + value;
                }
            }
        }
        if (backgroundColor) {
            const c = (0, color_1.default)(backgroundColor);
            // Get lightness (taking into account alpha)
            const lightness = 1 - (1 - c.luminosity()) * c.alpha();
            textColor = lightness < 0.3 ? "rgb(204,204,204)" : "inherit";
        }
        return react_1.default.createElement("td", { key: columnIndex, style: { backgroundColor, color: textColor } }, node);
    }
    renderRow(index) {
        return (react_1.default.createElement("tr", { key: index, onClick: this.handleRowClick.bind(null, index) }, lodash_1.default.map(this.props.columns, (column, i) => this.renderCell(index, i))));
    }
    renderBody() {
        return (react_1.default.createElement("tbody", { key: "body" }, lodash_1.default.map(this.state.data, (row, i) => this.renderRow(i))));
    }
    render() {
        return (react_1.default.createElement("table", { className: "mwater-visualization-table", style: { marginBottom: 0 } },
            this.renderHeader(),
            this.renderBody(),
            this.renderFooter()));
    }
}
